import React ,{ useRef,useEffect }  from 'react'
import './Front.css'
import frontImg from './../assets/front.png'
import { front_text } from '../constants'
import gsap from 'gsap'
import {TextPlugin} from 'gsap/TextPlugin'
import white_logo from '../assets/logo morade.png'
gsap.registerPlugin(TextPlugin);

export default function Front() {
    const bt = useRef();
    const tt = useRef();

    useEffect(() => {
        gsap.from([bt.current],{
            duration:3,
            text : ""
        });
        gsap.from([tt.current],{
            duration:4,
            text:""
        })
    },)
    return (
        <div className='front'>
            <img src={frontImg} alt='font is here' />
            <div className='front__layer' >
                <img src={white_logo} style={{height:'40vh'}} />
                <h1 style={{textAlign:"center"}} ref={bt} dangerouslySetInnerHTML={{__html:front_text.title}}>
                </h1>

                <p ref={tt}>
                    {
                    front_text.text
                    }
                </p>

            </div>
        </div>
    )
}
